import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlusSystemComponent } from './plus-system/plus-system.component';
import { PlusGalleryComponent } from './plus-gallery/plus-gallery.component';
import { PlusNoticeComponent } from './plus-notice/plus-notice.component';
import { PlusGalleryDetailsComponent } from './plus-gallery-details/plus-gallery-details.component';
import { PlusMapComponent } from './plus-map/plus-map.component';
import { PlusNoticeDetailsComponent } from './plus-notice-details/plus-notice-details.component';


const routes: Routes = [
  { 
    path: '', 
    children: [
      { path: 'plus-system', component: PlusSystemComponent },
      { path: 'plus-gallery', component: PlusGalleryComponent },
      { path: 'plus-gallery-detail', component: PlusGalleryDetailsComponent },
      { path: 'plus-notice', component: PlusNoticeComponent },
      { path: 'plus-notice-detail', component: PlusNoticeDetailsComponent },
      { path: 'plus-map', component: PlusMapComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})


export class PlusRoutingModule {

}